/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { BooleanPropertyConfig } from "./BooleanPropertyConfig";
import { BaseProperty } from "./BaseProperty";
export const BooleanProperty = core.serialization
    .object({
    config: BooleanPropertyConfig.optional(),
})
    .extend(BaseProperty);
